import type { JSX } from 'preact';
import { EmptyState } from '../components/FaultState';

// Phase 1 pages are shells: a header and a named empty-state (SPEC-001
// sequence — Home/Tasks/People/etc. become real in phases 2-7). The store,
// router, design system, nav and sign-out are this phase's real deliverable.
export function PageShell({ title, emptyLabel }: { title: string; emptyLabel: string }): JSX.Element {
  return (
    <div class="main">
      <div class="page-header">
        <h1>{title}</h1>
      </div>
      <EmptyState label={emptyLabel} />
    </div>
  );
}
